import { render, staticRenderFns } from "./TeamQuestionSlide.vue?vue&type=template&id=2376383c"
import script from "./TeamQuestionSlide.vue?vue&type=script&lang=js"
export * from "./TeamQuestionSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2376383c')) {
      api.createRecord('2376383c', component.options)
    } else {
      api.reload('2376383c', component.options)
    }
    module.hot.accept("./TeamQuestionSlide.vue?vue&type=template&id=2376383c", function () {
      api.rerender('2376383c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/TeamQuestionSlide.vue"
export default component.exports